import { Alert, Button, Col, Form, Input, Modal, Row, Table, Tooltip, DatePicker } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { EditOutlined, DeleteOutlined, PlusOutlined, EyeOutlined } from '@ant-design/icons';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import dayjs from 'dayjs';

function Holiday() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [isModal, setIsModal] = useState(false);
    const [dataModal, setdataModal] = useState(null);
    const [form] = Form.useForm();
    const [holidayDate, setHolidayDate] = useState(null);

    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
        sorter: {
            order: 'desc',
            columnKey: 'holiday_id',
        }
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);

    const titlePage = 'Holiday Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            sorter: true,
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: "date",
            render: (text) => text ? moment(text).format('YYYY-MM-DD') : "-",
        },
        {
            title: 'Created At',
            dataIndex: 'created_at',
            key: "created_at",
            sorter: true,
            render: (text, record) => record.created_at ? (<p>{moment(record.created_at).format('DD-MM-YYYY HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Updated At',
            dataIndex: 'updated_at',
            key: "updated_at",
            sorter: true,
            render: (text, record) => record.updated_at ? (<p>{moment(record.updated_at).format('YYYY-MM-DD HH:mm:ss')}</p>) : "-"
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <>
                    <Tooltip title="Detail">
                        <Button type="default" style={{ marginRight: 10 }} onClick={() => openDetail(record)}>
                            <EyeOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Edit">
                        <Button type="primary" style={{ marginRight: 10 }} onClick={() => openModal('edit', record)}>
                            <EditOutlined />
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button type="primary" danger onClick={() => modalDeleteData(record)}>
                            <DeleteOutlined />
                        </Button>
                    </Tooltip>
                </>
            ),
        },
    ];

    useEffect(() => {
        const order = page.sorter?.order === "ascend" ? 'asc' : 'desc';
        const columnKey = page.sorter?.columnKey || 'holiday_id';
        getApi("GET", `/holiday?search=${search}&page=${page.pagination.current}&limit=${page.pagination.pageSize}&sortBy=${columnKey}&order=${order}`, 'holiday');
    }, [JSON.stringify(page), isAlert]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method,
            url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setData(res.data);
                setPage({
                    ...page,
                    pagination: {
                        ...page.pagination,
                        total: res.meta.total
                    }
                });
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
        });
    }

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const payload = values ? {
            ...values,
            date: values.date ? moment(values.date).format("YYYY-MM-DD") : null
        } : null;

        const dataReq = {
            method,
            url,
            data: {
                data: payload,
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setdataModal(null);
                setIsAlert(true);
                setTextAlert(res.message);
                closeModal();
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.error(e.message);
        });
    }

    const modalDeleteData = (record) => {
        Modal.confirm({
            title: 'NOTICE',
            content: 'Do you want to delete this record?',
            onOk: () => postApi('DELETE', `/holiday/${record.holiday_id}`, null),
        });
    }

    const openModal = (type, data) => {
        if (type === 'edit') {
            setdataModal(data);
            setHolidayDate(
                data.date ? data.date : null
            );

            form.setFieldsValue({
                name: data.name,
                desc: data.desc,
                date: data.date ? dayjs(data.date) : null,
            });
        } else {
            setHolidayDate(null);
            form.resetFields();
        }

        setIsModal(true);
    }

    const onFinish = (values) => {
        const payload = {
            ...values,
            date: holidayDate
                ? moment(holidayDate).format("YYYY-MM-DD")
                : null,
        };
        
        if (dataModal) {
            postApi("PUT", `/holiday/${dataModal.holiday_id}`, payload);
        } else {
            postApi("POST", "/holiday", payload);
        }
    };


    const closeModal = () => {
        setdataModal(null);
        setHolidayDate(null);
        setIsModal(false);
        form.resetFields();
    }

    const openDetail = (record) => {
        Modal.info({
            title: 'Holiday Detail',
            content: (
                <div>
                    <p><b>Name:</b> {record.name}</p>
                    <p><b>Description:</b> {record.desc || '-'}</p>
                    <p><b>Date:</b> {record.date ? moment(record.date).format("YYYY-MM-DD") : '-'}</p>
                    <p><b>Created At:</b> {record.created_at ? moment(record.created_at).format("YYYY-MM-DD HH:mm:ss") : '-'}</p>
                    <p><b>Updated At:</b> {record.updated_at ? moment(record.updated_at).format("YYYY-MM-DD HH:mm:ss") : '-'}</p>
                </div>
            ),
            onOk() { },
        });
    };

    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({
            pagination: {
                current: 1,
                pageSize: 10,
            },
        });
    }

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Holiday</h3>
            <Row>
                <Col span={8}>
                    <Search
                        placeholder="Search"
                        allowClear
                        enterButton="Search"
                        size="middle"
                        onSearch={searchData}
                    />
                </Col>
                <Col span={16} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button style={{ marginBottom: 10 }} type="primary" onClick={() => openModal('add', null)}>
                        <PlusOutlined />
                        <b style={{ marginLeft: 5 }}>Add</b>
                    </Button>
                </Col>
            </Row>
            <Table
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />
            <Modal title="Holiday Data" open={isModal} onOk={form.submit} onCancel={closeModal} okText="Save">
                <Form form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        name="name"
                        label="Holiday Name"
                        rules={[{ required: true, message: 'Holiday Name is required!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="desc"
                        label="Description"
                    >
                        <Input.TextArea />
                    </Form.Item>
                    <Form.Item
                        name="date"
                        label="Date"
                        rules={[{ required: true, message: 'Date is required!' }]}
                    >
                        <DatePicker
                            format="YYYY-MM-DD"
                            style={{ width: '100%' }}
                            onChange={(e, dateString) => setHolidayDate(dateString)}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}

export default Holiday;
